<template lang="pug">
  div(class="urgent-trash-can block--normal")
    div(class="urgent-trash-can__title")
      span(class="font-18") 緊急垃圾桶
      span {{urgentCans.length}} / {{canIDs.length}}
    div(class="urgent-trash-can__container scroll-y")
      trash-can-wrapper(
        v-for="(urgentCan,index) in urgentCans"
        :key="`urgnet-can-${index}`"
        :urgentCan = "urgentCan" :index="index")

</template>

<script>

import TrashCanWrapper from '@/components/home/TrashCanWrapper.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'UrgentTrashCan',
  components: {
    TrashCanWrapper
  },
  props: {
    msg: String
  },
  computed: {
    ...mapGetters({
      urgentCans: 'getUrgentCans',
      canIDs: 'getCansID'
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/helper/variables.scss";

.urgent-trash-can {
  height: 100%;
  width: 70%;
  margin-right: 25px;
  &__title {
    display: flex;
    justify-content: space-between;
    > span:nth-child(2) {
      position: relative;
      font-size: 12px;
      &::after {
        content: "";
        position: absolute;
        width: 9px;
        height: 9px;
        top: 25%;
        left: -18px;
        border-radius: 50%;
        background-color: map-get($colors, dark-red);
      }
    }
  }
  &__container {
    height: 95%;
    box-sizing: border-box;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
